import { TransformKind } from "../display/SpriteConst";
import { LayoutBox } from "./LayoutBox";
export class HBox extends LayoutBox {
    get autoSizeMode() {
        return this._autoSizeMode;
    }
    set autoSizeMode(value) {
        if (this._autoSizeMode !== value) {
            this._autoSizeMode = value;
            this.callLater(this.changeItems);
        }
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Height) != 0)
            this.callLater(this.changeItems);
    }
    sortItem(items) {
        if (items)
            items.sort(function (a, b) { return a.x - b.x; });
    }
    changeItems() {
        this._itemChanged = false;
        const items = [];
        let maxChildHeight = 0;
        let totalChildWidth = 0;
        for (let i = 0, n = this.numChildren; i < n; i++) {
            const item = this.getChildAt(i);
            if (!item)
                continue;
            if (this.skipHidden && !item.visible)
                continue;
            item.x = 0;
            items.push(item);
            const iw = item.width * item.scaleX;
            const ih = item.height * item.scaleY;
            totalChildWidth += iw;
            if (ih > maxChildHeight)
                maxChildHeight = ih;
        }
        this.sortItem(items);
        const alignHeight = (this._autoSizeMode === HBox.AUTO_SIZE_BOTH) ? maxChildHeight : (this._isHeightSet ? this._height : maxChildHeight);
        let left = 0;
        for (let i = 0, n = items.length; i < n; i++) {
            const item = items[i];
            const iw = item.width * item.scaleX;
            const ih = item.height * item.scaleY;
            item.x = left;
            left += iw + this._space;
            switch (this._align) {
                case HBox.TOP:
                    item.y = 0;
                    break;
                case HBox.MIDDLE:
                    item.y = (alignHeight - ih) * 0.5;
                    break;
                case HBox.BOTTOM:
                    item.y = alignHeight - ih;
                    break;
            }
        }
        if (this._autoSizeMode === HBox.AUTO_SIZE_BOTH) {
            this.size(this._calcSizeWithSpace(totalChildWidth, items.length), maxChildHeight);
        }
        else if (this._autoSizeMode === HBox.AUTO_SIZE_WIDTH) {
            this.size(this._calcSizeWithSpace(totalChildWidth, items.length), this._height);
        }
        this._sizeChanged();
    }
}
HBox.NONE = "none";
HBox.TOP = "top";
HBox.MIDDLE = "middle";
HBox.BOTTOM = "bottom";
HBox.AUTO_SIZE_WIDTH = "width";
